module.exports = __webpack_public_path__ + "static/media/download.a67c8468.svg";